import React from "react";
import ProfileContainer from "../containers/Profile";
import MainLayout from "../layouts/MainLayout";
const Profile = () => {
  return (
    <MainLayout>
      <ProfileContainer />
    </MainLayout>
  );
};

export default Profile;
